
<router-outlet></router-outlet>
<app-cookie-consent></app-cookie-consent>

<!-- Aquí va el resto del contenido de tu aplicación -->

